import { NgModule } from '@angular/core';
import {Routes, RouterModule, Router, NavigationError} from '@angular/router';
import {filter} from 'rxjs/operators';
import {CallbackComponent} from '../auth-client/components/callback/callback.component';
import {LogoutComponent} from '../auth-client/components/logout/logout.component';
import {AuthGuard} from './guards/auth.guard';
import {RootComponent} from '../brover-default-component/root/root.component';
import {pageRoutes} from './routes/default';
import {SaveCardGuard} from './guards/save-card.guard';
import { OciComponent } from '../auth-client/components/oci/oci.component.ts';

const routes: Routes = [
  { path: 'dashboard', component: RootComponent, canActivate: [AuthGuard], children: pageRoutes},
    {path: 'oci/login', component: OciComponent},

  { path: 'auth/callback', component: CallbackComponent},
  { path: 'auth/logout', component: LogoutComponent},
  { path: '**', redirectTo: 'dashboard'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard, SaveCardGuard]
})
export class BroverRouterModule {
  constructor(private router: Router) {
    this.router.events.pipe(
      filter((e): e is NavigationError => e instanceof NavigationError)
    ).subscribe(() => {
      this.router.navigateByUrl('/');
    });
  }
}
